import debug from 'debug';
import CloudApi from 'Minetilbud/Shared/Components/CloudApi/Catalogs';

const log = debug('InspirationCatalogsByQuery:Data:CatalogsByQuery');

class CatalogsByQuery {
	/**
	 * @returns {Promise}
	 */
	async get(searchQuery) {
		try {
			const cloudapi = new CloudApi();
			const response = await cloudapi.CatalogsByQuery(searchQuery);

			log('get()', response);
			if (response.status !== 200) return [];

			const catalogs = response.json();

			return catalogs;
		} catch (error) {
			log('get() - ERROR', error);
		}
	}
}

export default CatalogsByQuery;
